<template>
  <div class="grid p-fluid" style="background-color:#F3F4F6">
    <div class="col-12 md:col-8">
      <!-- <div class="col-12 md:col-12" style="font-size: 14px;color: #333847;font-weight: 500;">Project information</div>
      <div class="card">
        <div class="form-view__cell form-view__cell--box">
          <div class="form-view__group form-view__group--items">
            <div class="form-view__cell form-view__cell--padding">
              <div class="form-view__label">Description</div>PACS - MAHARASHTRA - Delivery Report
            </div>
          </div>
          <div class="form-view__group form-view__group--items">
            <div class="form-view__cell form-view__cell--padding">
              <div class="form-view__label">Status</div>
              <div class="badge-module__root--ROiR2 badge-module__color-light-blue--bb_dk badge-module__size-s--hXRiw"><i
                  class="badge-module__icon--h1ayB k-icon--size-xs k-icon k-icon-project-deployed"></i><label
                  class="badge-module__label--Lmc3O">deployed</label></div>
            </div>
            <div class="form-view__cell form-view__cell--padding">
              <div class="form-view__label">Questions</div>8
            </div>
            <div class="form-view__cell form-view__cell--padding">
              <div class="form-view__label">Owner</div>
              <div class="avatar-module__root--gEeQU">
                <div class="avatar-module__initials--uZ3NT" style="background: rgb(255, 0, 45);">m</div>
                <label>maharashtrapacs</label>
              </div>
            </div>
          </div>
          <div class="form-view__group form-view__group--items">
            <div class="form-view__cell form-view__cell--padding">
              <div class="form-view__label">Last modified</div>December 27, 2023
            </div>
            <div class="form-view__cell form-view__cell--padding">
              <div class="form-view__label">Last deployed</div>December 27, 2023
            </div>
            <div class="form-view__cell form-view__cell--padding">
              <div class="form-view__label">Latest submission</div>Yesterday at 6:08 PM
            </div>
          </div>
          <div class="form-view__group form-view__group--items">
            <div class="form-view__cell form-view__cell--padding">
              <div class="form-view__label">Sector</div>Other
            </div>
            <div class="form-view__cell form-view__cell--padding">
              <div class="form-view__label">Country</div>India
            </div>
          </div>
        </div>
      </div> -->
      <div class="col-12 md:col-12" style="font-size: 14px;color: #333847;font-weight: 500;">Submissions</div>
      <div class="card" style="background-color: #fff;padding: 30px;">
        <loading :active="Submissions_isLoadingModel" :can-cancel="true" color="#173EA3"
          :is-full-page="Submissions_fullPage"></loading>
        
        <SelectButton v-model="selectButtonValue1" :options="selectButtonValues1" optionDisabled="constant"
          optionLabel="name" class="custom-select-button" />
        <Chart class="submissionsCountGraph-module__graph--uFiye submissionsCountGraph-module__graphVisible--NXvgv"
          type="bar" :data="barData" :options="barOptions" />
        <div class="submissionsCountGraph-module__statsWrapper--ma6Pd">
          <div class="submissionsCountGraph-module__stats--pfinV"><span
              class="submissionsCountGraph-module__statsCount--bHw9x">{{ total_filter_submission }}</span><time
              class="submissionsCountGraph-module__statsDateRange--h4Bwj">{{submission_from_date}} – Today</time></div>
          <div class="submissionsCountGraph-module__stats--pfinV"><span
              class="submissionsCountGraph-module__statsCount--bHw9x">{{ total_submission }}</span><span
              class="submissionsCountGraph-module__statsDateRange--h4Bwj">Total</span></div>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <!-- <div class="col-12 md:col-12" style="font-size: 14px;color: #333847;font-weight: 500;">Quick Links</div>
     
      <Menu :model="quick_link" style="width: 100%;" /> -->
    
      <div class="col-12 md:col-12" style="font-size: 14px;color: #333847;font-weight: 500;">Data</div>
      
      <Menu :model="data_menu" style="width: 100%;" />
     
    </div>
  </div>
</template>
<script>
import apis from "@/apis";
import EventBus from '@/AppEventBus';
export default {
  name: 'UiCodeTrackSummary',
  data() {
    return {
      submission_from_date:"",
      total_filter_submission: 0,
      total_submission: 0,
      Submissions_isLoadingModel: false,
      Submissions_fullPage: false,
      barData: {
        labels: [],
        height: "150px",
        datasets: [
          {
            label: 'Total Rides',
            backgroundColor: '#22C55E',
            data: []
          }
        ]
      },
      barData1: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
          {
            label: 'My First dataset',
            backgroundColor: '#2f4860',
            data: [65]
          }
        ]
      },
      barOptions: null,
      quick_link: [{
        label: 'Collect data',
        icon: 'pi pi-angle-right',
        command: () => {
          this.$toast.add({ severity: 'success', summary: 'Success', detail: 'File created', life: 3000 });
        }
      },
      {
        label: 'Preview form',
        icon: 'pi pi-angle-right',
        command: () => {
          this.$toast.add({ severity: 'success', summary: 'Success', detail: 'File created', life: 3000 });
        }
      }],
      data_menu: [
        // {
        //   label: 'Table',
        //   icon: 'pi pi-angle-right',
        //   command: () => {
        //     this.$toast.add({ severity: 'success', summary: 'Success', detail: 'File created', life: 3000 });
        //   }
        // },
        {
          label: 'Track Report',
          icon: 'pi pi-angle-right',
          command: () => {
            this.$emit("submit",'Track Report');    
          }
        },
        {
          label: 'Gallery',
          icon: 'pi pi-angle-right',
          command: () => {
            this.$emit("submit",'Gallery');  
          }
        },
        // {
        //   label: 'Downloads',
        //   icon: 'pi pi-angle-right',
        //   command: () => {
        //     this.$toast.add({ severity: 'success', summary: 'Success', detail: 'File created', life: 3000 });
        //   }
        // },
        // {
        //   label: 'Map',
        //   icon: 'pi pi-angle-right',
        //   command: () => {
        //     this.$toast.add({ severity: 'success', summary: 'Success', detail: 'File created', life: 3000 });
        //   }
        // }
      ],
      selectButtonValue1: null,
      selectButtonValues1: [
        { name: "Past 7 days", code: "7-DAYS" },
        { name: "Past 31 days", code: "31-DAYS" },
        { name: "Past 3 months", code: "3-MONTHS" },
        { name: "Past 12 months", code: "12-MONTHS" },
      ],
    };
  },
  created() {
    this.selectButtonValue1 = { "name": "Past 7 days", "code": "7-DAYS" };
    // this.get_data('7', 'DAYS');
    // this.get_submission_total();
  },
  mounted() {
    this.themeChangeListener = (event) => {
      if (event.dark)
        this.applyDarkTheme();
      else
        this.applyLightTheme();
    };
    EventBus.on('change-theme', this.themeChangeListener);
    if (this.isDarkTheme()) {
      this.applyDarkTheme();
    }
    else {
      this.applyLightTheme();
    }
  },
  beforeUnmount() {
    EventBus.off('change-theme', this.themeChangeListener);
  },
  watch: {
    selectButtonValue1: function (val) {
      if (this.selectButtonValue1.name && this.selectButtonValue1.code) {
        const regex = /(\d+)-([A-Za-z]+)/;
        const match = this.selectButtonValue1.code.match(regex);
        const numericValue = match[1]; // Extracts the numeric value
        const textValue = match[2];
        this.get_data(numericValue, textValue);
        this.get_submission_total();
        this.get_submission_total_filter(numericValue, textValue);
      }
    }
  },
  methods: {
    getPastDays(days) {
      const currentDate = new Date();
      const pastDays = [];
      for (let i = 0; i < days; i++) {
        const date = new Date(currentDate);
        date.setDate(currentDate.getDate() - i);
        const formattedDate = date.toISOString().split('T')[0];
        pastDays.push(formattedDate);
      }
      return pastDays.reverse();
    },
    getPastMonths(months) {
      const currentDate = new Date();
      const allDates = [];
      for (let i = 0; i < months; i++) {
        var year = currentDate.getFullYear();
        var month = currentDate.getMonth() - i;
        // Handling months that go below 0 (January of previous year)
        if (month < 0) {
          month += 12;
          year -= 1;
        }
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        for (let day = 1; day <= daysInMonth; day++) {
          const date = new Date(year, month, day);
          const formattedDate = date.toISOString().split('T')[0];
          allDates.push(formattedDate);
        }
      }
      return allDates;
    },
    getPastMonthYearStrings(months) {
      const currentDate = new Date();
      const pastMonthYearStrings = [];
      for (let i = 0; i < months; i++) {
        var year = currentDate.getFullYear();
        var month = currentDate.getMonth() - i;
        // Handling months that go below 0 (January of previous year)
        if (month < 0) {
          month += 12;
          year -= 1;
        }
        const monthYearString = `${(month + 1).toString().padStart(2, '0')}-${year}`;
        pastMonthYearStrings.push(monthYearString);
      }
      return pastMonthYearStrings.reverse();
    },
    async get_data(data, type) {
      var date_array = [];
      if (type == 'DAYS') {
        date_array = this.getPastDays(data);
      }
      else if (type == 'MONTHS') {
        date_array = this.getPastMonthYearStrings(data);
      }
      if (date_array.length > 0) {
        var client_id = localStorage.getItem("client_id");
        var client_group_ids = [];
        if (localStorage.getItem('client_group_ids')) {
          client_group_ids = JSON.parse(localStorage.getItem('client_group_ids'));
        }
        else {
          client_group_ids.push(localStorage.getItem('client_id'));
        }
        var details = {
          "client_id": client_id,
          "date_array": date_array
        }
        var promise = "";
        if (type == 'DAYS') {
          promise = apis.GetSummaryChart(details);
        }
        else if (type == 'MONTHS') {
          promise = apis.GetSummaryMonthlyChart(details);
        }
        this.Submissions_isLoadingModel = true;
        promise.then((response) => {
          this.Submissions_isLoadingModel = false;
          var list = response.data.data;
          if (list.length > 0) {
            this.barData.labels = [];
            this.barData.datasets[0].data = [];
            for (let index = 0; index < list.length; index++) {
              this.barData.labels.push(list[index].date);
              this.barData.datasets[0].data.push(list[index].count);
            }
          }
        });
      }
    },
    async get_submission_total() {
      var data = {
        client_id: localStorage.getItem("client_id")
      };
      var promise = apis.GetTotalSubmissions(data);
      promise.then((responseapi) => {
        this.total_submission = responseapi.data.data[0].sum;
      });
    },
     formatDate(inputDate) {
      const date = new Date(inputDate);
      const options = { year: 'numeric', month: 'short', day: '2-digit' };

      return date.toLocaleDateString('en-US', options);
    },
    async get_submission_total_filter(data, type) {
      var date_range = "";
      if (type == 'DAYS') {
        date_range = this.getPastDaysRange(data);
        
      }
      else if (type == 'MONTHS') {
        date_range = this.getPastMonthsRange(data);
      }
      this.submission_from_date = this.formatDate(date_range.startDate);
      var from_date = date_range.startDate;
      var to_date = date_range.endDate;
      var details = {
        client_id: localStorage.getItem("client_id"),
        from_date: from_date,
        to_date: to_date
      };
      var promise = apis.GetTotalFilterSubmissions(details);
      promise.then((responseapi) => {
        this.total_filter_submission = responseapi.data.data[0].sum;
      });
    },
    getPastDaysRange(numDays) {
        const endDate = new Date(); // Today's date
        const startDate = new Date();
        
        startDate.setDate(endDate.getDate() - (numDays - 1)); // Subtract (numDays - 1) days to get the start date

        // Format dates to 'YYYY-MM-DD'
        const formatDateString = date => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        const startDateString = formatDateString(startDate);
        const endDateString = formatDateString(endDate);

        return { startDate: startDateString, endDate: endDateString };
      },
    getPastMonthsRange(numMonths) {
      const endDate = new Date(); // Today's date
      const startDate = new Date();
      startDate.setMonth(endDate.getMonth() - numMonths); // Subtract numMonths months to get the start date
      // Format dates to 'YYYY-MM-DD'
      const formatDateString = date => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      const startDateString = formatDateString(startDate);
      const endDateString = formatDateString(endDate);
      return { startDate: startDateString, endDate: endDateString };
    },
    isDarkTheme() {
      return this.$appState.darkTheme === true;
    },
    applyLightTheme() {
      this.barOptions = {
        plugins: {
          legend: {
            labels: {
              color: '#495057'
            }
          },
        },
        scales: {
          x: {
            ticks: {
              color: '#495057'
            },
            grid: {
              color: '#ebedef',
            }
          },
          y: {
            ticks: {
              color: '#495057'
            },
            grid: {
              color: '#ebedef',
            }
          },
        }
      };
      this.barOptions1 = {
        indexAxis: 'y',
        plugins: {
          legend: {
            labels: {
              color: '#495057'
            }
          }
        },
        scales: {
          x: {
            ticks: {
              color: '#495057'
            },
            grid: {
              color: '#ebedef',
            }
          },
          y: {
            ticks: {
              color: '#495057'
            },
            grid: {
              color: '#ebedef',
            }
          },
        }
      };
      this.lineOptions = {
        plugins: {
          legend: {
            labels: {
              color: '#495057'
            }
          }
        },
        scales: {
          x: {
            ticks: {
              color: '#495057'
            },
            grid: {
              color: '#ebedef',
            }
          },
          y: {
            ticks: {
              color: '#495057'
            },
            grid: {
              color: '#ebedef',
            }
          },
        }
      };
    },
    applyDarkTheme() {
      this.lineOptions = {
        plugins: {
          legend: {
            labels: {
              color: '#ebedef'
            }
          }
        },
        scales: {
          x: {
            ticks: {
              color: '#ebedef'
            },
            grid: {
              color: 'rgba(160, 167, 181, .3)',
            }
          },
          y: {
            ticks: {
              color: '#ebedef'
            },
            grid: {
              color: 'rgba(160, 167, 181, .3)',
            }
          },
        }
      };
    }
  },
};
</script>
<style lang="scss" scoped>
.form-view__cell.form-view__cell--box {
  background-color: #fff;
}

.form-view__group.form-view__group--items:first-child {
  border-top: none;
}

.form-view__group.form-view__group--items {
  padding: 0;
  border-top: 1px solid #e7e9ee;
  display: flex;
  align-items: center;
}

.form-view__group.form-view__group--items {
  padding: 0;
  border-top: 1px solid #e7e9ee;
  display: flex;
  align-items: center;
}

.form-view__group.form-view__group--items {
  padding: 0;
  border-top: 1px solid #e7e9ee;
  display: flex;
  align-items: center;
}

.form-view__group.form-view__group--items {
  padding: 0;
  border-top: 1px solid #e7e9ee;
  display: flex;
  align-items: center;
}

.form-view__cell.form-view__cell--padding {
  padding: 20px;
}

.form-view__group.form-view__group--items>.form-view__cell .form-view__label {
  font-size: 12px;
  opacity: .6;
}

.form-view__cell.form-view__cell--padding {
  padding: 20px;
}

.avatar-module__root--gEeQU {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
}

.avatar-module__initials--uZ3NT {
  width: 20px;
  text-align: center;
  text-transform: uppercase;
  padding: 0 6px;
  border-radius: 20px;
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
  font-size: 12px;
  color: #fff;
  background-color: #7485b9;
}

.submissionsCountGraph-module__statsWrapper--ma6Pd {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  gap: 10px;
}

.submissionsCountGraph-module__stats--pfinV {
  flex: 1;
  border: 1px solid #e7e9ee;
  padding: 20px;
}

.submissionsCountGraph-module__statsCount--bHw9x {
  display: block;
  font-size: 32px;
  font-weight: 600;
  color: #53c5d0;
}

.submissionsCountGraph-module__statsDateRange--h4Bwj {
  display: block;
  margin-top: 8px;
}

.submissionsCountGraph-module__stats--pfinV {
  flex: 1;
  border: 1px solid #e7e9ee;
  padding: 20px;
}

.submissionsCountGraph-module__statsCount--bHw9x {
  display: block;
  font-size: 32px;
  font-weight: 600;
  color: #53c5d0;
}

.submissionsCountGraph-module__statsDateRange--h4Bwj {
  display: block;
  margin-top: 8px;
}

.submissionsCountGraph-module__graph--uFiye {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  position: relative;
  min-height: 150px;
  margin-bottom: 20px;
}

.submissionsCountGraph-module__periodSwitcher--vQfCV {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}</style>